import { type ComponentProps, useId } from 'react'

interface SelectFieldProps extends Omit<ComponentProps<'select'>, 'className'> {
  label: string
  invalid?: boolean
}

/**
 * A choice from a list, in the outlined style of the floating TextField: the
 * label small inside the top of the box, the browser's own menu beneath.
 */
export function SelectField({ label, invalid = false, id, children, ...props }: SelectFieldProps) {
  const generatedId = useId()
  const selectId = id ?? generatedId

  return (
    <div className="relative">
      <label
        htmlFor={selectId}
        className="pointer-events-none absolute top-2.5 left-4 text-xs text-field-ink"
      >
        {label}
      </label>
      <select
        {...props}
        id={selectId}
        aria-invalid={invalid || undefined}
        className="h-15 w-full appearance-none rounded-field border border-black/10 bg-white px-4 pt-6 pr-10 pb-1.5 text-base text-ink outline-none transition focus-visible:ring-2 focus-visible:ring-brand-ring disabled:opacity-60"
      >
        {children}
      </select>
      <svg
        className="pointer-events-none absolute top-1/2 right-4 -translate-y-1/2 text-ink-soft"
        width="12"
        height="12"
        viewBox="0 0 12 12"
        aria-hidden="true"
        fill="none"
      >
        <path
          d="M2.5 4.5 6 8l3.5-3.5"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  )
}
